import { HttpClient, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { throwError, of as observableOf, Subject, } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../auth/authentication.service';
import { UtilServiceService } from './utilService/util-service.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class PreventiveMaintenanceStandaloneService {
  

 public refreshList$: EventEmitter<any>;
 public getAssignedJobOrderTo$: EventEmitter<any>;
 public refreshAssetList$: EventEmitter<any>;
 /*******************************  Define endpoint *******************************/
private ENDPOINT_MAINTENANCE_PLAN = "/maintainance-plan";

  constructor(private http: HttpClient,
      private auth: AuthenticationService,
      private util: UtilServiceService
    ) { 
      this.refreshList$ = new EventEmitter();
      this.getAssignedJobOrderTo$ = new EventEmitter();
      this.refreshAssetList$ = new EventEmitter();

    }

public setAssignedJobOrderTo(data : any){
  this.getAssignedJobOrderTo$.emit(data);
}

  //************************************** Get All Maintenance Plans *************************************/
  public getAllMaintenancePlans(search: any, parameters: any, planType: any,filter:any, contractId:any = null) {
    console.log("FILTER IN SERVICE", filter);
      let params = new HttpParams();
      if (search !== "" && search != null) {
        params = params.set("search", search);
      }
      if(contractId){
        params = params.set("contractId", contractId);
      }
      if (planType) {
        params = params.set("planType", planType);
      }
      if (filter.status) {
        params = params.set("status", filter.status);
      }
      if(filter.intervalType){
        params = params.set("intervalType", filter.intervalType);
      }

      if (filter.startDateFrom && filter.startDateTo) {
        filter.startDateFrom = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(filter.startDateFrom, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
        filter.startDateTo = this.util.timeFormatter(moment("23:59:00", "h:mm A").format("h:mm A"), moment(filter.startDateTo, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();

        params = params.set("startDateFrom", filter.startDateFrom).set("startDateTo", filter.startDateTo);
    }

     if (filter.endDateFrom && filter.endDateTo ) {
       filter.endDateFrom = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(filter.endDateFrom, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
       filter.endDateTo = this.util.timeFormatter(moment("23:59:00", "h:mm A").format("h:mm A"), moment(filter.endDateTo, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();

      params = params
        .set("endDateFrom", filter.endDateFrom)
        .set("endDateTo", filter.endDateTo);
    }
      
      if (parameters)
        params = params.set('startFrom', parameters.startRow)
          .set('perPage', '25')
          .set('columnName', parameters.sortModel[0].colId)
          .set('sortOrder', parameters.sortModel[0].sort);
      return this.http.get(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN + '/paged', { observe: 'response', params: params }).pipe(map((resp: any) => {
        return resp;
      }
      ), catchError(error => {
        return throwError(error);
      }),);
    }
 /******************************************** get job order via params ******************************************/
  public getAllJobOrdersViaParams(filterObject: any, agGridParams: any,maintenancePlanId:any, assetId:any=null, havingMaintenancePlan:any=null) {
    console.log("CUSTOM PARAMS", filterObject);
    let params = new HttpParams();
    if(filterObject.maintenanceType){
    params = params.set("maintenancePlanType", filterObject.maintenanceType);
    }
    if (
      filterObject.hasOwnProperty("search") &&
      filterObject.search !== "" &&
      filterObject.search != null
    ) {
      params = params.set("search", filterObject.search);
    }

    if (
      filterObject.hasOwnProperty("status") &&
      filterObject.status !== "" &&
      filterObject.status !== null
    ) {
      params = params.set("jobOrderStatuses", filterObject.status);
    }
if (
      filterObject.hasOwnProperty("fromDate") &&
      filterObject.hasOwnProperty("toDate") &&
      filterObject.fromDate !== "" &&
      filterObject.toDate !== ""
    ) {
      params = params
        .set("fromDate", filterObject.fromDate)
        .set("toDate", filterObject.toDate);
    }
    if(maintenancePlanId){
      params = params.set("maintenancePlanId", maintenancePlanId);
    }
   
    if(assetId){
      params = params.set("assetsId", assetId);
    }
    if(havingMaintenancePlan != null){
      params = params.set("havingMaintenancePlan", havingMaintenancePlan);
    }

   
    if (agGridParams) {
      params = params
        .set("startFrom", agGridParams.startRow)
        .set("perPage", "25");

      params = params
        .set("columnName", agGridParams.sortModel[0].colId)
        .set("sortOrder", agGridParams.sortModel[0].sort);
    }

    return this.http .get(`${environment.base_url}/v4-1/job-orders`, { observe: "response", params: params   })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

//************************************** Get Maintenance Plan By ID *************************************/
public getMaintenancePlanById(id: any) {
  return this.http.get(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN + `/${id}`,{observe: "response"}).pipe(map((resp: any) => {
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),);
}
//************************************** Create Maintenance Plan *************************************/
public createMaintenancePlan(data: any) {
  return this.http.post(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN, data,{observe: "response"}).pipe(map((resp: any) => {
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),);
}

//************************************** Update Maintenance Plan *************************************/
public updateMaintenancePlan( data: any) {
  return this.http.put(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN, data,{observe: "response"}).pipe(map((resp: any) => {
    this.refreshList$.emit("Update Maintenance Plan");
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),);
}
//************************************** Delete Maintenance Plan *************************************/
public deleteMaintenancePlan(id: any) {
  return this.http.delete(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN + `/${id}`,{observe: "response"}).pipe(map((resp: any) => {
    this.refreshList$.emit("Delete Maintenance Plan");
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),);
}


  //************************************** Get All Maintenance Plans *************************************/
  public getAllMaintenancePlansAsset(search: any, parameters: any, maintainancePlanId: any, assetsId: any, filter: any) {
    console.log("FILTER IN SERVICE ASSET", filter);
     let params = new HttpParams();
      if (search !== "" && search != null) {
        params = params.set("search", search);
      }
      if (maintainancePlanId) {
        params = params.set("maintainancePlanId", maintainancePlanId);
      }
      if (assetsId) {
        params = params.set("assetsId", assetsId);
      }
      if (filter.assetStatusIds && filter.assetStatusIds.length > 0) {
        params = params.set("assetStatusIds", filter.assetStatusIds.join(","));
      }
      if(filter.maintainancePlanStatuses){
        params = params.set("maintainancePlanStatuses", filter.maintainancePlanStatuses);
      }

      if (filter.nextMaintenanceJobOrderStatuses && filter.nextMaintenanceJobOrderStatuses.length > 0) {
        params = params.set("nextMaintenanceJobOrderStatuses", filter.nextMaintenanceJobOrderStatuses.join(","));
      }
      if (filter.lastMaintenanceJobOrderStatuses && filter.lastMaintenanceJobOrderStatuses.length > 0) {
        params = params.set("lastMaintenanceJobOrderStatuses", filter.lastMaintenanceJobOrderStatuses.join(","));
      }
      if(filter.intervalType){
        params = params.set("intervalType", filter.intervalType);
      }

    

      if (filter.lastMaintenanceDateTimeFrom && filter.lastMaintenanceDateTimeTo ) {
    

      const fromDateISO = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"),moment(filter.lastMaintenanceDateTimeFrom).format("YYYY-MM-DD")).toISOString();
      const toDateISO = this.util.timeFormatter( moment("23:59:00", "h:mm A").format("h:mm A"), moment(filter.lastMaintenanceDateTimeTo).format("YYYY-MM-DD") ).toISOString();
    
      params = params
      .set("lastMaintenanceDateTimeFrom", fromDateISO)
      .set("lastMaintenanceDateTimeTo", toDateISO);

    }

      if (filter.nextMaintenanceDateTimeFrom && filter.nextMaintenanceDateTimeTo ) {
     
       const froNextmDateISO = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"),moment(filter.nextMaintenanceDateTimeFrom).format("YYYY-MM-DD")).toISOString();
      const toNextDateISO = this.util.timeFormatter( moment("23:59:00", "h:mm A").format("h:mm A"), moment(filter.nextMaintenanceDateTimeTo).format("YYYY-MM-DD") ).toISOString();
    

      params = params
        .set("nextMaintenanceDateTimeFrom", froNextmDateISO)
        .set("nextMaintenanceDateTimeTo", toNextDateISO);
    }
    
      
      if (parameters)
        params = params.set('startFrom', parameters.startRow)
          .set('perPage', '25')
          .set('columnName', parameters.sortModel[0].colId)
          .set('sortOrder', parameters.sortModel[0].sort);
      return this.http.get(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN + '/assets/paged', { observe: 'response', params: params }).pipe(map((resp: any) => {
        return resp;
      }
      ), catchError(error => {
        return throwError(error);
      }),);
    }

//

saveAutoApplyAssetToPlan(data: any) {
  return this.http.post(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN + '/assets-criteria', data,{observe: "response"}).pipe(map((resp: any) => {
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),);
}
updateAutoApplyAssetToPlan(data: any) {
  return this.http.put(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN + '/assets-criteria', data,{observe: "response"}).pipe(map((resp: any) => {
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),);
}
//************************************** Get Auto Apply Asset To Plan By ID *************************************/
public getAutoApplyAssetToPlan(id: any) {
  return this.http.get(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN + `/assets-criteria?maintenancePlanId=${id}`,{observe: "response"}).pipe(map((resp: any) => {
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),);
}
public getAllMaintenancePlansForMultipleAssets(search: any, filter: any, parameters: any, maintenancePlanId: any, filterOutPartOfOtherActiveHybridPlansAssets: any, meterBasedCustomUnitFrequencyValue: any) {
   
  console.log("FILTER IN SERVICE ASSET MULTIPLE", filter);
     let params = new HttpParams();
      if (search !== "" && search != null) {
        params = params.set("search", search);
      }
      if (filter.assetStatuses && filter.assetStatuses.length > 0) {
        params = params.set("assetStatuses", filter.assetStatuses.join(","));
      }
      if (filter.assetTypes && filter.assetTypes.length > 0) {
        params = params.set("assetTypes", filter.assetTypes.join(","));
      }
    if( maintenancePlanId){
        params = params.set("maintenancePlanId", maintenancePlanId);
      }
      if( filterOutPartOfOtherActiveHybridPlansAssets !== undefined){
        params = params.set("filterOutPartOfOtherActiveHybridPlansAssets", filterOutPartOfOtherActiveHybridPlansAssets);
      }
      if( meterBasedCustomUnitFrequencyValue !== undefined){
        params = params.set("meterBasedCustomUnitFrequencyValue", meterBasedCustomUnitFrequencyValue);
      }

      if (filter.fromDate && filter.toDate ) {
       const fromDateISO = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"),moment(filter.fromDate).format("YYYY-MM-DD")).toISOString();
      const toDateISO = this.util.timeFormatter( moment("23:59:00", "h:mm A").format("h:mm A"), moment(filter.toDate).format("YYYY-MM-DD") ).toISOString();
    
      params = params
      .set("createdDateTimeFrom", fromDateISO)
      .set("createdDateTimeTo", toDateISO);
    }

      if (parameters)
        params = params.set('startFrom', parameters.startRow)
          .set('perPage', '25')
          .set('columnName', parameters.sortModel[0].colId)
          .set('sortOrder', parameters.sortModel[0].sort);
      return this.http.get(environment.base_url  + '/v5/assets/for/maintenance-plan?page', { observe: 'response', params: params }).pipe(map((resp: any) => {
        return resp;
      }
      ), catchError(error => {
        return throwError(error);
      }),);
    }

  //************************************** Save Multiple Assets To Plan *************************************/
    saveMultipleAssetToPlan(data: any) {
    return this.http.post(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN + '/add/assets', data,{observe: "response"}).pipe(map((resp: any) => {
      return resp;
    }
    ), catchError(error => {
      return throwError(error);
    }),);
  }

    //************************************** Get All Maintenance Plans Sites *************************************/
  public getAllMaintenancePlansSites(search: any, parameters: any, maintainancePlanId: any, siteId: any, filter: any) {
     let params = new HttpParams();
     console.log(filter)
      if (search !== "" && search != null) {
        params = params.set("search", search);
      }
      if (maintainancePlanId) {
        params = params.set("maintainancePlanId", maintainancePlanId);
      }
      if (siteId) {
        params = params.set("siteId", siteId);
      }

       if (filter.siteStatus !== null && filter.siteStatus !== '') {
        params = params.set("siteStatus", filter.siteStatus);
      }
      if(filter.maintainancePlanStatuses){
        params = params.set("maintainancePlanStatuses", filter.maintainancePlanStatuses);
      }

      if (filter.nextMaintenanceJobOrderStatuses && filter.nextMaintenanceJobOrderStatuses.length > 0) {
        params = params.set("nextMaintenanceJobOrderStatuses", filter.nextMaintenanceJobOrderStatuses.join(","));
      }
      if (filter.lastMaintenanceJobOrderStatuses && filter.lastMaintenanceJobOrderStatuses.length > 0) {
        params = params.set("lastMaintenanceJobOrderStatuses", filter.lastMaintenanceJobOrderStatuses.join(","));
      }

    

      if (filter.lastMaintenanceDateTimeFrom && filter.lastMaintenanceDateTimeTo ) {
      //  filter.lastMaintenanceDateTimeFrom = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(filter.lastMaintenanceDateTimeFrom, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      //  filter.lastMaintenanceDateTimeTo = this.util.timeFormatter(moment("23:59:00", "h:mm A").format("h:mm A"), moment(filter.lastMaintenanceDateTimeTo, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();

      // params = params
      //   .set("lastMaintenanceDateTimeFrom", filter.lastMaintenanceDateTimeFrom)
      //   .set("lastMaintenanceDateTimeTo", filter.lastMaintenanceDateTimeTo);

         const fromDateISO = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"),moment(filter.lastMaintenanceDateTimeFrom).format("YYYY-MM-DD")).toISOString();
      const toDateISO = this.util.timeFormatter( moment("23:59:00", "h:mm A").format("h:mm A"), moment(filter.lastMaintenanceDateTimeTo).format("YYYY-MM-DD") ).toISOString();
    
      params = params
      .set("lastMaintenanceDateTimeFrom", fromDateISO)
      .set("lastMaintenanceDateTimeTo", toDateISO);

    }

      if (filter.nextMaintenanceDateTimeFrom && filter.nextMaintenanceDateTimeTo ) {
       const froNextmDateISO = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"),moment(filter.nextMaintenanceDateTimeFrom).format("YYYY-MM-DD")).toISOString();
       const toNextDateISO = this.util.timeFormatter( moment("23:59:00", "h:mm A").format("h:mm A"), moment(filter.nextMaintenanceDateTimeTo).format("YYYY-MM-DD") ).toISOString();
    

      params = params
        .set("nextMaintenanceDateTimeFrom", froNextmDateISO)
        .set("nextMaintenanceDateTimeTo", toNextDateISO);
     
    }
    

      
      if (parameters)
        params = params.set('startFrom', parameters.startRow)
          .set('perPage', '25')
          .set('columnName', parameters.sortModel[0].colId)
          .set('sortOrder', parameters.sortModel[0].sort);
      return this.http.get(environment.base_url +this.ENDPOINT_MAINTENANCE_PLAN + '/sites/paged', { observe: 'response', params: params }).pipe(map((resp: any) => {
        return resp;
      }
      ), catchError(error => {
        return throwError(error);
      }),);
    }
   

  public getAllMaintenancePlansForMultipleSite(search: any, filter: any, parameters: any, maintenancePlanId: any) {
     let params = new HttpParams();
      if (search !== "" && search != null) {
        params = params.set("search", search);
      }
      if (filter.siteStatusIds && filter.siteStatusIds.length > 0) {
        params = params.set("siteStatusIds", filter.siteStatusIds.join(","));
      }
      if (filter.typeIds && filter.typeIds.length > 0) {
        params = params.set("typeIds", filter.typeIds.join(","));
      }
      if( maintenancePlanId){
        params = params.set("maintenancePlanId", maintenancePlanId);
      }
    

      if (filter.fromDate && filter.toDate ) {
        const fromDateISO = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"),moment(filter.fromDate).format("YYYY-MM-DD")).toISOString();
      const toDateISO = this.util.timeFormatter( moment("23:59:00", "h:mm A").format("h:mm A"), moment(filter.toDate).format("YYYY-MM-DD") ).toISOString();
    
      params = params
      .set("createdDateTimeFrom", fromDateISO)
      .set("createdDateTimeTo", toDateISO);

     
    }

      if (parameters)
        params = params.set('startFrom', parameters.startRow)
          .set('perPage', '25')
          .set('columnName', parameters.sortModel[0].colId)
          .set('sortOrder', parameters.sortModel[0].sort);
      return this.http.get(environment.base_url  + '/v4-1/sites/for/maintenance-plan', { observe: 'response', params: params }).pipe(map((resp: any) => {
        return resp;
      }
      ), catchError(error => {
        return throwError(error);
      }),);
    }
    //************************************** Save Multiple Assets To Plan *************************************/
    saveMultipleSiteToPlan(data: any) {
    return this.http.post(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN + '/add/sites', data,{observe: "response"}).pipe(map((resp: any) => {
      return resp;
    }
    ), catchError(error => {
      return throwError(error);
    }),);
  }

  //************************************** Update Maintenance Plan *************************************/
public updateMaintenancePlanStatus( maintenancePlanId: any,status:any) {
  return this.http.put(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN+'/update/status?maintenancePlanId='+maintenancePlanId+'&status='+status, {},{observe: "response"}).pipe(map((resp: any) => {
    this.refreshList$.emit("Plan Status Update");
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),);
}

//************************************** Update Maintenance Plan *************************************/
public cloneMaintenancePlan( data: any) {
  return this.http.put(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN+'/clone', data,{observe: "response"}).pipe(map((resp: any) => {
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),);
}
public adjustNextMaintenanceDate(data: any,plantype:any) {
  return this.http.put(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN+'/'+plantype+'/cycle/update', data,{observe: "response"}).pipe(map((resp: any) => {
   this.refreshAssetList$.emit("Next Maintenance Date Updated");
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),); 
}
public generateJobOrderForNextMaintenanceDate(id: any) {
  return this.http.put(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN+`/asset/cycle/trigger-jo-generation?assetsMaintenancePlanId=${id}`,{observe: "response"}).pipe(map((resp: any) => {
   this.refreshAssetList$.emit("Next Maintenance Date Job Order Generated");
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),);
}
public generateJobOrderForSiteForNextMaintenanceDate(id: any) {
  return this.http.put(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN+`/site/cycle/trigger-jo-generation?sitesMaintenancePlanId=${id}`,{observe: "response"}).pipe(map((resp: any) => {
   this.refreshAssetList$.emit("Next Maintenance Date Job Order Generated");
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),);
}

//************************************** Delete Auto Apply Conditions *************************************/
public deleteAutoApplyConditions(id: any) {
  return this.http.delete(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN + `/assets-criteria/${id}`,{observe: "response"}).pipe(map((resp: any) => {
    this.refreshList$.emit("Delete Assets Criteria Plan");
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),);
}
//************************************** Delete Maintenance Plan Asset *************************************/
public deleteMaintenancePlanAsset(maintainancePlanId: any,assetId:any) {
  return this.http.put(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN + `/remove/assets?maintainancePlanId=${maintainancePlanId}&assetId=${assetId}`,{observe: "response"}).pipe(map((resp: any) => {
    this.refreshAssetList$.emit("Delete Maintenance Plan Asset");
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),);
}
//************************************** Delete Maintenance Plan Site *************************************/
public deleteMaintenancePlanSite(maintainancePlanId: any,siteId:any) {
  return this.http.put(environment.base_url + this.ENDPOINT_MAINTENANCE_PLAN + `/remove/sites?maintainancePlanId=${maintainancePlanId}&siteId=${siteId}`,{observe: "response"}).pipe(map((resp: any) => {
    this.refreshAssetList$.emit("Delete Maintenance Plan Site");
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),); 
}
}